// Prevent multiple clicks and control button enablement based on checkbox selection
(function () {
  var $placeOrderButton = $('#placeOrderForm1 #placeOrder');
  var $placeOrderForm = $('#placeOrderForm1');
  var $termsCheckbox = $('#Terms1');
  var $businessTermsCheckbox = $('#businessTermsCheckbox');

  // Disable button initially
  function updatePlaceOrderState() {
    if ($termsCheckbox.prop('checked') && $businessTermsCheckbox.prop('checked')) {
      $placeOrderButton.prop('disabled', false);
    } else {
      $placeOrderButton.prop('disabled', true);
    }
  }

  $termsCheckbox.on('change', updatePlaceOrderState);
  $businessTermsCheckbox.on('change', updatePlaceOrderState);

  updatePlaceOrderState();

  // Prevent multiple submissions
  $placeOrderForm.submit(function () {
    if (!$placeOrderButton.prop('disabled')) {
      $placeOrderButton.prop('disabled', true);
      return true;
    }
    return false;
  });
})();
